'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TracksCount = require('components/TracksCount/TracksCount');

var _TracksCount2 = _interopRequireDefault(_TracksCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./MyPlaylistItem.scss');

var MyPlaylistDescription = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(MyPlaylistDescription, _PureComponent);

  function MyPlaylistDescription() {
    (0, _classCallCheck3.default)(this, MyPlaylistDescription);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistDescription.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistDescription)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistDescription, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          tracksCount = _props.tracksCount;


      return _react2.default.createElement(
        'div',
        { className: styles.description },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          name
        ),
        _react2.default.createElement(_TracksCount2.default, { count: tracksCount })
      );
    }
  }]);
  return MyPlaylistDescription;
}(_react.PureComponent), _class.propTypes = {
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), //TODO: fix api
  tracksCount: _propTypes2.default.number
}, _class.defaultProps = {
  tracksCount: 0
}, _temp);
exports.default = MyPlaylistDescription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/components/MyPlaylistDescription.js
// module id = 2173
// module chunks = 1